import { createSelector } from 'reselect'

const getLocoSpace = state => state.locoSpace

export const selectPriceAlertList = createSelector(
  [getLocoSpace],
  locoSpace => locoSpace.priceAlertList,
)

export const selectExpiredPriceAlertList = createSelector(
  [getLocoSpace],
  locoSpace => locoSpace.priceAlertExpiredList,
)

export const selectPriceAlertWithDealsAndVehicleList = createSelector(
  [getLocoSpace],
  locoSpace => locoSpace.priceAlertWithDealsAndVehicleList,
)

export const selectExpiredPriceAlertWithVehicleList = createSelector(
  [getLocoSpace],
  locoSpace => locoSpace.expiredPriceAlertWithVehicleList,
)

export const selectPriceAlertManufacturerList = createSelector([getLocoSpace], locoSpace => {
  const list = locoSpace.priceAlertWithDealsAndVehicleList

  const manufacturers = list.map(item => {
    return {
      name: item.vehicle.manufacturerName,
      id: item.vehicle.manufacturer,
    }
  })

  const filteredManufacturers = manufacturers.filter(
    (value, index, self) =>
      index === self.findIndex(t => t.place === value.place && t.name === value.name),
  )

  return filteredManufacturers
})

export const selectComparisonVehicles = createSelector(
  [getLocoSpace],
  locoSpace => locoSpace.comparison,
)

export const selectVehiclesInComparisonCount = createSelector(
  [getLocoSpace],
  locoSpace => locoSpace.comparison.length,
)

export const selectArePriceAlertsStale = createSelector(
  [getLocoSpace],
  locoSpace => locoSpace.stalePriceAlerts,
)
